module.exports = __webpack_public_path__ + "img/refresh.99407177.svg";